import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

function loadLocaleMessages() {
  const locales = require.context("./", true, /[A-Za-z0-9-_,\s]+\.json$/i);
  const messages = {};
  locales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}
function getLanguage() {
  let userCountry = localStorage.getItem("myTeam_Dash_user_country");
  console.log("userCountry", userCountry);
  // if (userCountry !== "null") {
  if (
    userCountry === null ||
    userCountry === "null" ||
    userCountry === "" ||
    userCountry === "مصر"
  ) {
    // console.log("userCountry is not null");
    return "ar";
  } else if (userCountry === "المانيا") {
    return "de";
  } else {
    return "en";
  }
  // return "en";
}
// console.log("getLanguage", getLanguage());
const i18n = new VueI18n({
  // locale: localStorage.getItem("myTeam_Dash_Lang") || "en",

  locale: getLanguage(),
  fallbackLocale: "ar",
  messages: loadLocaleMessages(),
});

export default i18n;
